import CssBaseline from "@mui/material/CssBaseline";
import { StyledEngineProvider, ThemeProvider } from "@mui/material/styles";
import React from "react";
import { computeErrorMessage } from "reusable/fetching/fetchWithErrorHandling";
import GapDialog, { GapDialogProps } from "reusable/gap-dialog/GapDialog";
import { modalConfig } from "reusable/mui/modals/modal-theme";

export default class ErrorBoundary extends React.Component<{ children: JSX.Element }> {
   state = { error: undefined }

   static getDerivedStateFromError(error: any) {
      return { error }
   }
   render() {
      if (this.state.error) {
         const dialogProps: GapDialogProps = {
            DialogProps: { maxWidth: 'xl', fullWidth: true },
            children: <>
               Please refresh your browser and try again. If this issue persists please contact Support.
               <br /><br /> <pre>{computeErrorMessage(this.state.error)}</pre>
            </>,
            title: "Something went wrong",
            primary: {
               name: 'Reload App',
               callback: () => window.location.reload()
            }
         }
         return <StyledEngineProvider injectFirst>
            <ThemeProvider theme={modalConfig.theme}>
               <CssBaseline />
               <GapDialog
                  {...dialogProps}
               />
            </ThemeProvider>
         </StyledEngineProvider>
      }
      return this.props.children
   }
}
